export default __webpack_public_path__ + "static/media/screen.e14e6f5d.png";